import React, { useEffect, useState, useRef } from 'react';

import {
    Box,
    Breadcrumbs,
    Divider,
    Link,
    Stack,
    Typography,
    Paper,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    InputAdornment,
    IconButton,
    List,
    ListSubheader,
    ListItemButton,
    ListItemText,
    ListItemIcon,
    ListItem,
    Chip,
    Grid,
    Skeleton,
    FormControl,
    styled,
    Checkbox,
    Tooltip
} from '@mui/material';

import { CommonIcons, icons } from "../../../../components/common/CommonIcons"

import { useSystemPrompt } from "../../../../hooks/useSystemPrompt"
import { useTranslations } from "../../../../hooks/useTranslations";

import { useMarking, markingInjectionProps } from "../../hooks/model/useMarking"

const StyledTitle = styled(Box)(({ theme }) => ({
    fontWeight: 800,
    fontSize: '1.0rem'
}))

const StyledSubTitle = styled(Box)(({ theme }) => ({
    fontWeight: 300,
    fontSize: '0.8rem'
}))

export default function SearchCustomerMarkings({
    routeType,
    id,
    handleOnCancel,
    handleOnSelect,
    config,
    textProps,
    configs = {
        onlyShowIconSearch: false,
        IconSearchComponent: null
    }
}) {

    const { t } = useTranslations({ ns: ["common", "_@products"] })

    const searchInputRef = useRef()

    const [open, setOpen] = useState(false)
    const [keyword, setKeyword] = useState("")
    const [data, setData] = useState([])

    const [checkedKeyword, setCheckedKeyword] = useState(false)
    const { promptMessage } = useSystemPrompt()

    const { isLoading, listMarkings, filterOperatorTypes } = useMarking({ routeType })

    const fetchData = async () => {

        try {

            let filterValues = []

            if (checkedKeyword === true) {
                filterValues.push({
                    name: markingInjectionProps.marking.retrieveKey,
                    operator: filterOperatorTypes.eq,
                    value: keyword
                })
            }

            let props = {
                limit: 30,
                skip: 0,
                sortInfo: {
                    id: "id",
                    dir: -1,
                },
                // filterValue: [
                //     // {
                //     //     name: `status`,
                //     //     operator: filterOperatorTypes.eq,
                //     //     value: 1,
                //     //     // group: "name_group"
                //     // },
                //     // {
                //     //     name: `${markingInjectionProps.marking.retrieveKey}`,
                //     //     operator: filterOperatorTypes.contains,
                //     //     value: (keyword),
                //     //     // group: "name_group"
                //     // },
                //     // {
                //     //     name: "company_name",
                //     //     operator: filterOperatorTypes.eqOr,
                //     //     value: keyword,
                //     //     group: "name_group"
                //     // },
                // ]
                filterValue: filterValues
            }

            let { data: _data } = await listMarkings({
                props,
                status: `1`,
                markingKeyword: keyword
            });

            // let data = _data.filter(i => {

            //     let marking = i[markingInjectionProps.marking.retrieveKey]
            //     let isActive = true
            //     let isDelete = false
            //     let disableSelect = false

            //     // check for inactive item
            //     if (marking.toLowerCase().search("inactive") >= 0) {
            //         isActive = false
            //     }

            //     // check for deleted item
            //     if (marking.toLowerCase().search("deleted") >= 0) {
            //         isDelete = true
            //     }

            //     if (isActive === false || isDelete === true) {
            //         disableSelect = true
            //     }

            //     if (disableSelect === false) {
            //         return true
            //     }

            //     return false

            // })

            let data = _data.filter(i => {
                let marking = i[markingInjectionProps.marking.retrieveKey]?.toLowerCase() ?? ""
                const isActive = !marking.includes("inactive")
                const isDeleted = marking.includes("deleted")
                return isActive && !isDeleted
            })

            setData(data)

        } catch (error) {
            promptMessage(false, `${error.message}`)
        }
    }

    useEffect(() => {
        setData([])
    }, []) // checkedKeyword

    useEffect(() => {

        if (keyword) {
            fetchData({ keyword });
        } else {
            setKeyword("")
            setData([])
        }

    }, [keyword, checkedKeyword])

    useEffect(() => {

        const timeout = setTimeout(() => {

            if (open) {
                searchInputRef?.current.focus();
            }

        }, 100);

        return () => {
            clearTimeout(timeout);
        };

    }, [open])

    const handleSearchEqualKeyword = (event) => {
        setCheckedKeyword(event.target.checked)
    }

    const RenderListData = () => {

        if (isLoading) {
            return (
                [1, 2, 3, 4].map((item, index) => <RenderListDataItem key={index} isLoading={Boolean(true)} />)
            )
        }

        return (
            data.map((item, index) =>
                <RenderListDataItem key={index} item={item} index={index} />
            )
        )
    }

    const RenderListDataItemSkeleton = () => {
        return (
            <>
                <Skeleton
                    animation="wave"
                    sx={{
                        minWidth: 100,
                        mr: 1,
                        height: 50
                    }}
                />
                <ListItemText>
                    <Skeleton variant="rectangular" width={"100%"} height={20} />
                    <Skeleton variant="rectangular" width={"100%"} height={20} sx={{ mt: 1 }} />
                </ListItemText>
            </>
        )
    }

    const RenderListDataItemDisplay = ({ item }) => {

        // console.log('item', item)

        return (<>
            <Grid container padding={1}>
                <Grid item md={1} textAlign={"center"} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                    <CommonIcons name={icons.package} sx={{ height: 30, width: 30 }} />
                </Grid>

                <Grid item md={7}>
                    <StyledTitle
                        sx={{
                            fontSize: 20
                        }}
                    >
                        {
                            item[markingInjectionProps.marking.retrieveKey]
                        }
                    </StyledTitle>
                    {/* <StyledSubTitle>
                        {`${item?.address_1} ${item?.address_2}`}
                    </StyledSubTitle>
                    <StyledSubTitle>
                        {`${item?.postcode} ${item?.area_name}  ${item?.state_name}, ${item?.country_name}`}
                    </StyledSubTitle> */}
                </Grid>
                <Grid item md={4} textAlign={"right"}>
                    {/* <Stack
                        direction={"column"}
                        justifyContent={"flex-end"}
                    > */}
                    {/* <Chip
                        // label={
                        //     `${item[markingInjectionProps.marking.retrieveKey]}`
                        // }
                        label={
                            item?.company_name
                        }
                        color={"primary"}
                        variant='contained'
                        sx={{
                            // fontWeight: 800
                        }}
                    /> */}
                    <StyledSubTitle sx={{ ml: 1 }}>
                        {item?.company_name}
                    </StyledSubTitle>
                    {/* </Stack> */}
                </Grid>
            </Grid>
        </>
        )
    }

    const RenderListDataItem = ({ isLoading = false, index, item }) => {

        let isActive = true
        let isDelete = false
        let disableSelect = false

        if (isLoading === false) {

            let marking = item[markingInjectionProps.marking.retrieveKey]

            // check for inactive item
            if (marking.toLowerCase().search("inactive") >= 0) {
                isActive = false
            }

            // check for deleted item
            if (marking.toLowerCase().search("deleted") >= 0) {
                isDelete = true
            }

            if (isActive === false || isDelete === true) {
                disableSelect = true
            }

            // console.log('marking', marking, isActive, isDelete)
        }

        // const checked = checkedItems[item.id] ?? true

        return (
            <ListItem
                key={index}
                disablePadding
                divider
            >
                <ListItemButton
                    role={undefined}
                    onClick={() => {
                        handleSelect({ item, id: item?.id });
                    }}
                    dense
                    disabled={disableSelect}
                >
                    {/* {
                        isLoading === false &&
                        <>
                            [Active : {JSON.stringify(isActive)}]
                            [Delete : {JSON.stringify(isDelete)}]
                        </>
                    } */}

                    {
                        Boolean(isLoading) ? <RenderListDataItemSkeleton /> : <RenderListDataItemDisplay item={item} />

                    }

                </ListItemButton>
            </ListItem>
        )
    }

    const RenderList = () => {
        return (
            <List
                component="nav"
                aria-labelledby="nested-list-subheader"
                subheader={
                    <ListSubheader
                        component="div"
                        id="nested-list-subheader"
                    >
                        <Paper
                            elevation={3}
                            sx={{ p: 1 }}
                        >
                            {/* <FormControl variant="standard"> */}
                            <TextField
                                inputRef={searchInputRef}
                                autoComplete="off"
                                margin="dense"
                                size="small"
                                label={t('searchKeyword')}
                                fullWidth
                                variant="outlined"
                                onChange={e => {
                                    setKeyword(e.target.value)
                                }}
                                value={keyword}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <CommonIcons name={icons.search} />
                                        </InputAdornment>
                                    ),
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <Box
                                                display={"flex"}
                                                flexDirection={"row"}
                                                alignItems="center"
                                                width={120}
                                                sx={{ m: 1 }}
                                            >
                                                <Checkbox
                                                    size="medium"
                                                    onChange={handleSearchEqualKeyword}
                                                    checked={checkedKeyword}
                                                />
                                                <Typography fontSize={15} fontWeight={600}>
                                                    {
                                                        (checkedKeyword === false) ? t("filterAll") : t("filterSimilar")
                                                    }
                                                </Typography>
                                            </Box>
                                        </InputAdornment>
                                    )
                                }}
                            />
                            {/* </FormControl> */}
                        </Paper>
                    </ListSubheader>
                }
            >
                {
                    RenderListData()
                }

            </List>
        )
    }

    const handleExit = () => {
        setOpen(false);

        if (handleOnCancel)
            handleOnCancel();
    }

    const handleSelect = ({ id, item }) => {
        setOpen(false);

        if (handleOnSelect)
            handleOnSelect({ id, item })

        promptMessage(true, t('selected1Item'))
    }

    const IconSearchComponentDefault = <CommonIcons name={icons.search} />

    const RenderSearch = () => {

        if (configs.onlyShowIconSearch === true) {
            return (
                <IconButton
                    sx={{
                        m: 0,
                        // p: 0
                    }}
                    aria-label="open"
                    onClick={() => setOpen(true)}
                    color={"primary"}
                >
                    {
                        configs.IconSearchComponent ?
                            configs.IconSearchComponent
                            :
                            IconSearchComponentDefault
                    }
                </IconButton>
            )
        }

        return (
            <TextField
                // disabled
                disabled={textProps?.disabled ? textProps.disabled : false}
                margin="normal"
                size="small"
                fullWidth
                name={id}
                label={t('selectCustomer')}
                type="text"
                variant="outlined"
                value={textProps?.value ? textProps.value : ""}
                // onChange={handleChange}
                error={textProps?.error ? textProps.error : false}
                helperText={textProps?.helperText}
                InputProps={{
                    sx: { pr: 0.5 },
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                sx={{ m: 0 }}
                                aria-label="open"
                                onClick={() => setOpen(true)}
                            >
                                {
                                    configs.IconSearchComponent ?
                                        configs.IconSearchComponent
                                        :
                                        IconSearchComponentDefault
                                }
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
            />
        )
    }

    return (
        <Box>

            {
                RenderSearch()
            }

            {/* {JSON.stringify(configs.open)} */}

            <Dialog
                sx={{
                    '& .MuiDialog-paper':
                    {
                        // width: '80%', 
                        minHeight: '90vh'
                    }
                }}
                fullWidth
                maxWidth="md"
                // TransitionProps={{ onEntering: handleEntering }}
                open={open}
                // {...other}
                onClose={handleExit}
            >
                <DialogTitle
                >
                    {
                        config?.dialogDisplayText ? config.dialogDisplayText : t('searchCustomer')
                    }

                    <IconButton
                        aria-label="close"
                        onClick={handleExit}
                        sx={{
                            position: 'absolute',
                            right: 10,
                            top: 10,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CommonIcons name={icons.close} />
                    </IconButton>

                </DialogTitle>
                <DialogContent
                    dividers
                    // minHeight="100%"
                    sx={{
                        // backgroundColor: 'red',
                        pl: 0,
                        pr: 0
                    }}
                >

                    {
                        RenderList()
                    }

                </DialogContent>
                {/* <DialogActions>
                    <Button 
                        autoFocus 
                        // onClick={handleCancel}
                        onClick={() => {
                            handleOnCancel()
                        }}
                    >Cancel</Button>
                    <Button 
                        // onClick={handleOk}
                        onClick={() => {
                            handleOnConfirm()
                        }}
                    >Ok</Button>
                </DialogActions> */}
            </Dialog>
        </Box>
    )
}